import { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'

import { favoriteConfirm, favoriteAdd, favoriteRemove } from './service'

import { $cookie } from '$utils'
// 图片合集 相关事件
const useSlider = ({ imgs }) => {
  const [offset, setOffset] = useState(0) // 缩略图偏移量
  const slider = useRef() // slider 实例
  const [currentPicNum, setCurrentPicNum] = useState(0) // 当前图序

  // 缩略图 事件
  const prePic = () => {
    slider?.current?.slick?.slickPrev()
  }
  const nextPic = () => {
    slider?.current?.slick?.slickNext()
  }
  const goToPic = (num) => {
    slider?.current?.slick?.slickGoTo(num)
  }
  const beforeGalleryChange = (current, next) => {
    setCurrentPicNum(next)
  }

  useEffect(() => {
    goToPic(currentPicNum)
    if (currentPicNum < 3) {
      setOffset(0)
    } else if (currentPicNum > 2 && currentPicNum < imgs.length - 2) {
      setOffset(-(currentPicNum - 2) * 122)
    } else {
      setOffset(-(imgs.length - 4) * 122)
    }
  }, [currentPicNum])

  return [
    slider,
    currentPicNum,
    offset,
    {
      prePic,
      nextPic,
      goToPic,
      beforeGalleryChange,
      setCurrentPicNum
    }
  ]
}

// 收藏
const useFavorite = ({ carId }) => {
  const _token = $cookie.get('rrc_login_token')
  const { phone, token } = useSelector(store => store.user)
  const [isFavorite, setFavorite] = useState(false)
  const favoriteParam = {
    token: token || _token,
    car_id: carId,
    os: 'pc',
    device_type: 'pc',
    record_data: carId,
    record_type: '1'
  }

  const changeFavorite = () => {
    const fn = async (ismsg, data) => {
      const _favoriteParam = {
        token: token || _token || data.token,
        car_id: carId,
        os: 'pc',
        device_type: 'pc',
        record_data: carId,
        record_type: '1'
      }
      try {
        if (!isFavorite) {
          await favoriteAdd(_favoriteParam)
          global.$rbl.push({
            event: '收藏成功弹窗弹出',
            content: { param: { car_id: carId, pageName: 'car-detail' } }
          })
          // new UseModalSuccess({
          //   title: '收藏成功',
          //   codeType: 'favorite_common'
          // }).open()
        } else {
          await favoriteRemove(_favoriteParam)
          global.$rbl.push({
            event: '收藏取消按钮点击成功',
            content: { param: { car_id: carId, pageName: 'car-detail' } }
          })
        }
        setFavorite(!isFavorite)
      } catch (error) {
        setFavorite(false)
      }
    }
    if (!phone || !token) {
      // new UseLogin({ onSuccessCallBack: data => fn(false, data) }).open()
      const referpath = window.location.href
      // if (referpath.indexOf('?') > -1) {
      //   referpath += '&type=favorite'
      // } else {
      //   referpath += '?type=favorite'
      // }
      localStorage.setItem('loginBackCarid', carId)
      window.location.href = `${
        window.location.origin
      }/login?source=${encodeURIComponent(referpath)}`
    } else {
      fn(true)
    }
  }

  const confirmFavorite = async () => {
    if (!phone || !token) {
      setFavorite(false)
      return false
    }
    try {
      const lc = localStorage.getItem('loginBackCarid')
      localStorage.removeItem('loginBackCarid')
      if (lc) {
        await changeFavorite()
      } else {
        const result = await favoriteConfirm(favoriteParam)
        setFavorite(result.data.is_fav)
      }
      return true
    } catch (error) {
      return false
    }
  }

  useEffect(() => {
    confirmFavorite()
  }, [carId, phone && token])

  return [isFavorite, changeFavorite]
}

export { useFavorite, useSlider }
